<template>
  <b-col
    cols="12"
    md="4"
    class="d-flex align-items-center justify-content-start mb-1 mb-md-0 pull-left"
  >
    <label>Filtrer </label>
    <v-select
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      :value="statusFilter"
      :options="statusOptions"
      class="per-page-selector d-inline-block mx-300"
      style="width: 150px"
      :reduce="(val) => val.value"
      @input="(val) => $emit('update:statusFilter', val)"
    />
  </b-col>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    statusFilter: {
      type: [String, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
